module.exports = __webpack_public_path__ + "static/media/nike-eor-winner-1.35b06a4e.jpg";